import {
  type,
  pipe,
  map,
  prop,
  propOr,
  props,
  lensIndex,
  over,
  flatten,
  join,
  applyTo,
  zipObj,
} from 'ramda'
import Maybe from 'folktale/maybe'
import isJson from '@v/util/isJson.js'

const formatApiError = (e, defaultUserMessage = 'Something went wrong') =>
  Maybe.fromNullable(e.response?.data?.message)
    .chain(m => (isJson(m) ? Maybe.Just(JSON.parse(m)) : Maybe.Nothing()))
    .chain(m => (typeof m === 'object' ? Maybe.Just(m) : Maybe.Nothing()))
    .matchWith({
      Just: pipe(
        prop('value'),
        getMessagesArray(e, defaultUserMessage),
        zipObj(['errorMessage', 'userMessage']),
      ),
      Nothing: () => ({
        errorMessage: e.response || e,
        userMessage: defaultUserMessage,
      }),
    })

const getMessagesArray = (e, defaultUserMessage) => v =>
  map(applyTo(v), [formatErrorMessage(e), pipe(propOr(defaultUserMessage, 'FriendlyDescription'))])

const formatErrorMessage = e =>
  pipe(
    props(['TechnicalDescription', 'AdditionalInformation']),
    over(lensIndex(0), formatStartingLines(e)),
    over(lensIndex(1), formatAdditionalInformation),
    flatten,
    join('\n'),
  )

const formatStartingLines = e => technicalDescription => [
  String(e),
  `TechnicalDescription: ${technicalDescription}`,
  '=== AdditionalInformation ===',
]

const formatAdditionalInformation = additionalInfo =>
  Object.entries(additionalInfo).flatMap(([propPath, messages]) =>
    type(messages) === 'Array'
      ? messages.map(m => `${propPath}: ${m}`)
      : [`${propPath}: ${messages}`],
  )

export default formatApiError
